<template>
  <div class="col s12 m12 l12">
      <div>
        <h6>Coronavirus updates of {{this.TotalCountries}} Countries - {{DateT.split(" ",4)[0]}}, {{DateT.split(" ",4)[1]}}
         {{DateT.split(" ",4)[2]}}, {{DateT.split(" ",4)[3]}}</h6>
        <hr>
      </div>
      <div class = "container">
        
        <!-- Spinner -->
        <div class="loadings container" id="loading" v-if="LoadingMSG">
    <div class="preloader-wrapper big active">
      <div class="spinner-layer spinner-blue">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>

      <div class="spinner-layer spinner-red">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>

      <div class="spinner-layer spinner-yellow">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>

      <div class="spinner-layer spinner-green">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </div>
        <!-- Spinner -->
      <div v-else>
         <table  class="striped responsive-table highlight">
           <thead>
            <tr>
              <th>Total Cases</th>
              <th>Total Deaths</th>
              <th>Total Recovered</th>
              <th>Death %</th>
            </tr>
           </thead>
           <tbody>
            <tr>
              <td class="cases">{{this.coid19.cases.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
              <td class="deaths" >{{this.coid19.deaths.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
              <td class="recovered" >{{this.coid19.recovered.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
              <td class="perce" >{{Math.ceil((100 * this.coid19.deaths)/(this.coid19.cases)) + "%"}}</td>
            </tr>
           </tbody>
         </table>
        <br>


         <hr>
         <table class="striped responsive-table highlight">
          <thead>
            <tr >
                <th>Country</th>
                <th>Cases</th>
                <th>Recovered</th>
                <th>Deaths</th>
                <th>Active Cases</th>
            </tr>
          </thead>

          <tbody>
           <tr>
              <td >{{this.AfgCovid19.country}}</td>
              <td class="cases">{{this.AfgCovid19.cases}}</td>
              <td class="recovered">{{this.AfgCovid19.recovered}}</td>
              <td class="deaths">{{this.AfgCovid19.deaths}}</td>
              <td class="perce">{{this.AfgCovid19.active}}</td>
            </tr>
            <tr v-for="( post, index ) in pageOfItems" :key="index">
              <!-- <td>{{post.last_updated}}</td> -->
              <!-- <td>{{post.countries}}</td> -->
              <td>{{post.country}}</td> 
              <td class="cases">{{post.cases.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td> 
              <td class="recovered">{{post.recovered}}</td>
              <td class="deaths">{{post.deaths.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
              <td class="perce">{{post.active}}</td>
              <!-- <td v-if="post.Marks==0" class="red lighten-4">{{post.Marks}}</td>
              <td v-else>{{post.Marks}}</td> -->
            <input type="hidden" name="som" v-model="pageOfItems">
          
            </tr>
          
          </tbody>
         </table>
      
          <ul class="pagination">
            <li class="waves-effect orange"><a class="paginate" href="#!" id="1" v-on:click="goToFirst">First</a></li>
            <li class="disabled"><a href="#!"><i class="material-icons">chevron_left</i></a></li>
            <li class="active"><a href='#!' v-bind:id="p" v-on:click="goToFirst">{{p}}</a></li>
            <li class="waves-effect"><a href="#!" v-bind:id="p+1" v-on:click="goToPage1">{{p+1}}</a></li>
            <li class="waves-effect"><a href="#!" v-bind:id="p+2" v-on:click="goToPage2">{{p+2}}</a></li>
            <li class="waves-effect"><a href="#!" v-bind:id="p+3" v-on:click="goToPage3">{{p+3}}</a></li>
            <li class="waves-effect"><a href="#!" v-bind:id="p+4" v-on:click="goToPage4">{{p+4}}</a></li>
            <li class="waves-effect"><a href="#!" v-bind:id="p+5" v-on:click="goToPage5"><i class="material-icons">chevron_right</i></a></li>
            <li class="waves-effect orange "><a class="paginate" v-on:click="goToLast" href="#!" v-bind:id="p+6">Last</a></li>
          </ul>
       
      </div>
      </div>
      <div>
        <hr>
        <p><b>Data Source:</b> https://www.worldometers.info/coronavirus/</p>
        <p><b>Date:</b> {{DateT.split(" ",4)[0]}}, {{DateT.split(" ",4)[1]}}
         {{DateT.split(" ",4)[2]}}, {{DateT.split(" ",4)[3]}}</p>
        
        
      </div>
  </div>
</template>
<script>

var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
s1.async=true;
s1.src='https://embed.tawk.to/5e7c592669e9320caabd260a/default';
s1.charset='UTF-8';
s1.setAttribute('crossorigin','*');
s0.parentNode.insertBefore(s1,s0);
})();

export default {
  name:"",
  data(){
    return{
      coid19:"",
      covid19:"",
      LoadingMSG:true,
      AfgCovid19:"",
      TotalCountries:0,
      DateT:Date(),
      page:1,
      pageOfItems:"",
      Total_Pages:0,
      Rec_Per_Page:10,
      Page_Pointer:0,
      p:1

    }
  },
  methods:{

    goToLast(){          
            this.pageOfItems = this.covid19.slice(210,this.covid19.length);
    },
    goToFirst(){          
            this.pageOfItems = this.covid19.slice(0,11);
    },
    goToPage1(){          
            this.pageOfItems = this.covid19.slice(12,22);
    },
    goToPage2(){          
            this.pageOfItems = this.covid19.slice(23,33);
    },
    goToPage3(){          
            this.pageOfItems = this.covid19.slice(34,44);
    },
    goToPage4(){          
            this.pageOfItems = this.covid19.slice(45,55);
    },
    goToPage5(){          
            this.pageOfItems = this.covid19.slice(56,66);
    },

    fetchCovid19:function(){
      this.LoadingMSG=true;
       fetch('https://coronavirus-19-api.herokuapp.com/countries') //,{ mode: 'same-origin' }
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.LoadingMSG=false;
        this.covid19 = data;
        this.Total_Pages=Math.ceil(data.length/this.Rec_Per_Page);
        this.pageOfItems = this.covid19.slice(0,10);
      
          for (var i = 0; i < this.covid19.length; i++){
          // look for the entry with a matching `code` value
            if (this.covid19[i].country == "Afghanistan"){
              this.AfgCovid19=this.covid19[i];
              this.TotalCountries=this.covid19.length;
              return;
            }
          }
      });
    },
  fetchPosts:function(){

      // this.$http.get('https://interactive-static.scmp.com/sheet/wuhan/viruscases.json',{ mode: 'no-cors' }).then(function(data){
      // this.coid19=data;
      // console.log(this.coid19);
      //     });

    fetch('https://coronavirus-19-api.herokuapp.com/all') //,{ mode: 'same-origin' }
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.coid19 = data;
        // console.log(this.coid19);
      });
    }
  },
  mounted() {
    //onChangePage();
  },
  created(){
    this.fetchPosts();
    this.fetchCovid19();
  }
}
</script>
<style scoped>
.cases{
  /* padding: 1%; */
  color: rgb(0, 0, 0);
  background-color: rgb(230, 193, 126);
  /* font-size: 1.5em; */
    text-align: center;
}
.deaths{
  /* padding: 1%; */
  color: rgb(0, 0, 0);
  background-color: rgb(248, 144, 144);
  /* font-size: 1.5em; */
  text-align: center;
}
.recovered{
  /* padding: 1%; */
  color: rgb(0, 0, 0);
  background-color: rgb(174, 245, 160);
  /* font-size: 1.5em; */
    text-align: center;
}
.perce{
   /* padding: 1%; */
  color: rgb(252, 5, 5);
  background-color: rgb(241, 241, 241);
  /* font-size: 1.5em; */
    text-align: center;
}

</style>
